import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { catchError } from 'rxjs/operators';
// import { environment } from 'src/environments/environment';
// import { ErrorhandlingService } from './errorhandling.service';
// import { CryptoService } from './services/crypto.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private decryptedPermissions: string = null;

  constructor(private router: Router, 
              // private ErrorhandlingService: ErrorhandlingService,
              // private cryptoService: CryptoService
              ) { }
  
  get isLoggedIn(): boolean {
    return localStorage.getItem('userToken') != null;
  }

  setLoggedIn(idcliente: string, nombre: string, userName: string, token: string) {
    localStorage.setItem('IdCliente', idcliente);
    localStorage.setItem('userName', userName);
    localStorage.setItem('Nombre', nombre);
    localStorage.setItem('userToken', token);
    this.router.navigate(['portalpagos']);//
  }

  get getUserId(): string {
    return localStorage.getItem('IdCliente');
  }

  get getUserName(): string {
    return localStorage.getItem('userName');
  }

  get getUserCompleteName(): string {
    return localStorage.getItem('Nombre');
  }

  get getUserToken(): string {
    // var decryptedToken = this.cryptoService.get(this.getCryptoKey, localStorage.getItem('userToken'));
    return localStorage.getItem('userToken');
  }

  get getCryptoKey(): string {
    // original document had this key '123456$#@$^@1ERF';
    return '190315$#@$^@1ERF';
  }

  // hasAccess(permission: string): boolean {
  //   var result: boolean = false;

  //   if(!this.decryptedPermissions && localStorage.getItem('permisos'))
  //   {
  //     this.decryptedPermissions = this.cryptoService.get(this.getCryptoKey, localStorage.getItem('permisos'));
  //   }
    
  //   const permissions = JSON.parse(this.decryptedPermissions);    
    
  //   if(permissions){
  //     result = permissions.filter(row => row.nombreitem == permission && row.acceso == "1").length > 0;
  //   }    

  //   return result;
  // }

  // login(userName: string, password: string) {
  //   var httpParams = JSON.stringify({ usuario: userName, password: password });

  //   let httpHeaders = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //     'no-auth': 'True',
  //   });

  //   let options = {
  //     headers: httpHeaders
  //   };

  //   return this.http.post(environment.apiURL + 'login.php', httpParams, options)
  //     .pipe(
  //       catchError(this.ErrorhandlingService.handleError('login', []))
  //     );
  // }

  logout() {
    // localStorage.removeItem('userToken');    
    // this.router.navigate(['pages/login']);

    // localStorage.removeItem('permisos');
    // localStorage.removeItem('avatar');

    // this.decryptedPermissions = null;

    localStorage.removeItem('IdCliente');
    localStorage.removeItem('userName');
    localStorage.removeItem('Nombre');
    localStorage.removeItem('userToken');
    this.router.navigate(['inicio']);

  }

  // lock() {
  //   localStorage.removeItem('userToken');    
  //   localStorage.setItem('isLocked', 'true');
  //   this.router.navigate(['pages/lock']);

  //   localStorage.removeItem('permisos');
  //   this.decryptedPermissions = null;
  // }

  // setAvatar(avatar:any){
  //   localStorage.setItem('avatar', avatar);
  // }
}
